module.exports = __webpack_public_path__ + "media/apps/mitch-ios-4-5032cdcc.png";